import { faImage, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { supabase } from '../../api';
import useModal from '../../helpers/useModal';
import ELNStore from '../../store';
import Modal from '../Modal';
import { STORAGE_URL } from '../../helpers/utils';




export const Photo = ({bucket, path, disabled, filename, step, ext = 'jpg', onStatusUpdate, order, random, onRemove}) => {

    const currentUser = ELNStore.useState(s => s.currentUser);

    const [status, setStatus] = useState('LOADING')
    const { showModal, toggleModal } = useModal()

    const handleFailure = () => {
        setStatus('FAILED')
        if (onStatusUpdate) onStatusUpdate(false)
    }

    const handleSuccess = () => {
        setStatus('LOADED')
        if (onStatusUpdate) onStatusUpdate(true)
    }

    const handleUpload = async (e) => {
        const selectedFile = e.target.files[0]

        const sizeInMB = selectedFile.size / (1024 * 1024)

        if (sizeInMB > 2) {
            alert('Please select an image smaller than 2MB')
            return
        } 

        const { data, error } = await supabase
        .storage
        .from(bucket)
        .upload(`${path}/${filename}.${ext}`, selectedFile, {
            cacheControl: '3600',
            upsert: false
        })

        if (error) console.error(error)
        if (data) setStatus('LOADED')
        
    }

    const handleRemove = async () => {
        if (!window.confirm('Really remove this image?')) {
            return
        }
        const { data, error } = await supabase
        .storage
        .from(bucket)
        .remove([`${path}/${filename}.${ext}`])
        if (error) console.error('Error sent ', error)
        if (data) {
            onRemove()
        }
    }

    const fullFileName = `${bucket}/${path}/${filename}.${ext}`
    
    const hasPermission = order ? currentUser.p_orders>=2 : currentUser.p_speccards>=2



    if (status === 'FAILED') return (
        <div className={`photoWrapper`}>
            {hasPermission &&
            <><label className={`file-upload-button ${disabled ? 'disabled' : ''}`} for={`photo-upload-${path}-${filename}`}><FontAwesomeIcon icon={faImage} /> &nbsp;Add photo</label>
            <input disabled={disabled} id={`photo-upload-${path}-${filename}`} type="file" accept=".jpg,.jpeg" onChange={handleUpload} /></>}
            {step && <div className='photoStep'>{step}</div>}
        </div>)


    else return (
        <>
        <Modal isShowing={showModal} hide={toggleModal} showHeader={false}>
        <img onClick={toggleModal} className='photo-fullsize' src={`${STORAGE_URL}/object/public/${fullFileName}?random=${random}`} alt={fullFileName} />
        </Modal>
        <div className={`photoWrapper photoShown`}>
            {status === 'LOADED' ? <button disabled={disabled} className='inv' onClick={handleRemove}><FontAwesomeIcon icon={faTimes} /></button> : ''}
            <img className='photo' onClick={toggleModal} src={`${STORAGE_URL}/object/public/${fullFileName}?random=${random}`} onError={handleFailure} onLoad={handleSuccess} alt={fullFileName} />
            {step && <div className='photoStep'>{step}</div>}
        </div>
        </>
    )
    
  }

export default Photo;